import {
  MaritalInformationFormT,
  MaritalInformationRequestT,
  MaritalInformationSpouseRequestT,
  MaritalInformationSpouseT,
} from '../../types';
import { addressTransform } from '../address/address';

export const serializeSpouse = (spouse: MaritalInformationSpouseT): MaritalInformationSpouseRequestT => {
  const address = spouse.address && addressTransform.serialize(spouse.address);

  return {
    spouse_apt_or_unit: address?.apt_or_unit,
    spouse_city: address?.city,
    spouse_first_name: spouse.firstName,
    spouse_home_address: address?.home_address,
    spouse_last_name: spouse.lastName,
    spouse_postal_code: address?.postal_code,
    spouse_state: address?.state,
  };
};

export const serializeMaritalInformation = (maritalInformation: MaritalInformationFormT): MaritalInformationRequestT => {
  return {
    marital_status: maritalInformation.maritalStatus,
    ...(maritalInformation.spouse && serializeSpouse(maritalInformation.spouse)),
  };
};
